import React from 'react';
import { Icons } from '../constants';

export const Logo = ({ className = "w-8 h-8" }: { className?: string }) => (
  <div className={`flex items-center justify-center bg-transparent rounded-xl ${className}`}>
    <img src="/icon-512x512.png" alt="GreenTree Logo" className="w-full h-full object-contain" onError={(e) => {
      // Fallback if image not uploaded yet
      e.currentTarget.style.display = 'none';
      e.currentTarget.nextElementSibling?.classList.remove('hidden');
    }} />
    <div className="hidden w-full h-full bg-gecko text-white rounded-xl flex items-center justify-center">
      <Icons.Tree />
    </div>
  </div>
);

export const BrandName = ({ className = "" }: { className?: string }) => (
  <div className={`flex flex-col ${className}`}>
    <span className="font-black tracking-tight leading-none">GREENTREE</span>
    <span className="text-[0.6em] font-bold uppercase tracking-widest text-gecko leading-none mt-1">Arboriculture</span>
  </div>
);
